<div class="content">
    <div class="d-flex mb-2" style="align-items: center; justify-content: space-between">
        <span>{{'Attachment' | translate}}</span>
    </div>
    <div class="gallery-container">
        <div class="card inner-shadow">
            <div class="card-body">
                <p class="title text-left">{{ 'Photos' | translate }}</p>
                <div style="padding-top: 1em; padding-bottom: 1em; height: 100px;">
                    <app-file-upload (onSelected)="onPhotosSelected($event, 'image')" [isDisable]="photoProgress>=0"></app-file-upload>
                </div>
                <div class="d-flex align-items-center mb-3" *ngIf="photoProgress>=0">
                    <span>Uploaded {{_uploadedSelectedFiles}} of {{_allSelectedFiles}}...</span>
                    <div class="spinner-border text-secondary ml-auto spinner-grow-sm" role="status" aria-hidden="true"></div>
                </div>
                <mat-progress-bar *ngIf="photoProgress>=0" mode="determinate" value={{photoProgress}}>
                </mat-progress-bar>
                <div class="list-group">
                    <div class="list-group-item" *ngIf="photos.length > 0">
                        <div class="form-check d-flex align-items-center flex-grow-1">
                            <input class="form-check-input" type="checkbox" [indeterminate]="isAllCheckboxIndeterminate" (change)="onChangeAllCheckbox($event)">
                        </div>
                        <div class="d-flex">
                            <button class="btn btn-sm btn-danger" (click)="onDeleteSelected()" [disabled]="selectedIdToDelete.length === 0">Delete Selected &nbsp;<i class="icon-delete"></i></button>
                        </div>
                    </div>
                    <div class="list-group-item" *ngFor="let photo of photos; let idx = index; trackById">
                        <div class="form-check d-flex align-items-center">
                            <input class="form-check-input" type="checkbox" [checked]="selectedIdToDelete.includes(photo.id)" (change)="onChangeSelectedCheckbox($event, photo.id)">
                        </div>
                        <div class="thumbnail"
                            [ngStyle]="{'background-image': 'url(' + (photo.url_small || photo.url) + ')'}"></div>
                        <div class="details" [title]="photo.filename">
                            <p>{{ photo.filename | translate }}</p>
                            <p>{{'Uploaded at' | translate}} {{ photo.created_at | date }}</p>
                        </div>
                        <div *ngIf="!photo.status" style="display: flex; flex-direction: column;">
                            <a href="{{photo.url}}" download target="_blank"><i class="icon-download"></i></a>
                            <a style="color: crimson;" (click)="onDelete(photo)">
                                <i class="icon-delete"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <p class="item-counter text-center">{{this.photos?.length}} {{ 'Photos' | translate }}</p>
            </div>
        </div>
    </div>
    <div class="gallery-container">
        <div class="card inner-shadow">
            <div class="card-body">
                <p class="title text-left">{{ 'Files' | translate }}</p>
                <div style="padding-top: 1em; padding-bottom: 1em; height: 100px;">
                    <app-file-upload (onSelected)="onPhotosSelected($event, 'file')"></app-file-upload>
                </div>
                <div class="list-group">
                    <div class="list-group-item" *ngFor="let file of files; trackById">
                        <div class="file"
                            style="background-image: url(https://icon-library.com/images/file-icon/file-icon-6.jpg);">
                        </div>
                        <div class="details">
                            <p>{{ file.filename }}</p>
                            <p>{{'Uploaded at' | translate}} {{ file.created_at | date }}</p>
                        </div>
                        <div *ngIf="!file.status" style="display: flex; flex-direction: column;">
                            <a href="{{file.url}}" download target="_blank"><i class="icon-download"></i></a>
                            <a style="color: crimson;" (click)="onDelete(file)">
                                <i class="icon-delete"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <p class="item-counter text-center">{{this.files?.length}} {{ 'Files' | translate }}</p>
            </div>
        </div>
    </div>
    <div class="gallery-container">
        <div class="card inner-shadow">
            <div class="card-body">
                <p class="title text-left">{{ 'Videos' | translate }}</p>
                <div style="padding-top: 1em; padding-bottom: 1em; height: 100px;">
                    <app-file-upload (onSelected)="onPhotosSelected($event, 'video')"></app-file-upload>
                </div>
                <div class="list-group">
                    <div class="list-group-item" *ngFor="let video of videos; trackById">
                        <div class="file"
                            style="background-image: url(https://icon-library.com/images/file-icon/file-icon-6.jpg);">
                        </div>
                        <div class="details">
                            <p>{{ video.filename }}</p>
                            <p>{{'Uploaded at' | translate}} {{ video.created_at | date }}</p>
                        </div>
                        <div *ngIf="!video.status" style="display: flex; flex-direction: column;">
                            <a href="{{video.url}}" download target="_blank"><i class="icon-download"></i></a>
                            <a style="color: crimson;" (click)="onDelete(video)">
                                <i class="icon-delete"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <p class="item-counter text-center">{{this.videos?.length}} {{ 'Videos' | translate }}</p>
            </div>
        </div>
    </div>
</div>